<template>
    <div class="row">
        <div class="col-12 position-relative mb-5">
            <h5 class="text-center">CHANGE OWNER</h5>
            <a href="#!"
               class="qf-close-modal"
               @click.prevent="closeModal">
                <font-awesome-icon icon="times"/>
            </a>
        </div>
        <div class="col-12">
            <form @submit.prevent="saveOwner">
                <div class="row justify-content-center mb-5 position-relative">
                    <div class="col-8">
                        <label for="owner">Select owner</label>
                        <select name="owner"
                                id="owner"
                                class="form-control"
                                v-model="owner"
                                :disabled="loading">
                            <option value="-1" disabled>Select owner</option>
                            <option v-for="ownerItem in owners" :value="ownerItem" :key="ownerItem.id">
                                {{ownerItem.name}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-right">
                        <button class="btn btn-outline-dark"
                                type="button"
                                @click="closeModal"
                                :disabled="loading">
                            <font-awesome-icon icon="times"/>&nbsp;&nbsp;&nbsp;Cancel
                        </button>
                    </div>
                    <div class="col">
                        <button type="submit"
                                class="btn btn-warning"
                                :disabled="loading || owner === -1">
                            <font-awesome-icon icon="spinner"
                                               class="fa-spin"
                                               v-if="loading"/><font-awesome-icon icon="save" v-else/>&nbsp;&nbsp;&nbsp;Save
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ChangeOwner",
        props: {
            Ids: Array,
            modalOpened: Boolean,
            type: String
        },
        watch: {
            modalOpened(value) {
                if (!value) {
                    this.owner = -1
                }
            }
        },
        data() {
            return {
                owners: [],
                loading: true,
                owner: -1,
            }
        },
        mounted() {
            this.loading = true;
            this.$store.dispatch('owners').then(response => {
                this.owners = response;
                this.loading = false;
            });
        },
        methods: {
            closeModal() {
                this.$emit('closeModal')
            },
            saveOwner() {
                let data
                if (this.type == 'opposition') {
                    data = {
                        action: 'owner',
                        ownerId: this.owner.id,
                        oppositions: this.Ids
                    };
                    this.loading = true;
                    this.$store.dispatch('bulkOpposition', data).then(() => {
                        this.$emit('changeOwners', this.owner);
                        this.loading = false;
                    }).catch(() => {
                        this.loading = false;
                    })  
                } else {
                    data = {
                        action: 'owner',
                        ownerId: this.owner.id,
                        brands: this.Ids
                    };
                    this.loading = true;
                    this.$store.dispatch('bulk', data).then(() => {
                        this.$emit('changeOwners', this.owner);
                        this.loading = false;
                    }).catch(() => {
                        this.loading = false;
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>
